/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivityFromJSON, ActivityToJSON, } from "./Activity";
/**
 * Check if a given object implements the SportsActivitiesResponse interface.
 */
export function instanceOfSportsActivitiesResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "activities" in value;
    return isInstance;
}
export function SportsActivitiesResponseFromJSON(json) {
    return SportsActivitiesResponseFromJSONTyped(json, false);
}
export function SportsActivitiesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        activities: json.activities.map(ActivityFromJSON),
    };
}
export function SportsActivitiesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        activities: value.activities.map((a) => ActivityToJSON(a)),
    };
}
